import { FC, useContext } from "react";

import { Stack } from "capitalrx-components-2.0/lib/layout";
import styles from "./MedicalClaimsSearchPage.module.scss";

import { AuthenticationContext } from "@/context";
import { MedicalClaimsProviderList, MedicalClaimsSearchForm } from "../../components";

export const MedicalClaimsSearchPage: FC = () => {
  const { isUserLoggedIn } = useContext(AuthenticationContext);

  return (
    <div className={!isUserLoggedIn() ? styles.MedicalClaimsPanelContainer : styles.MedicalClaimsProviderContainer}>
      <Stack spacing="large">
        {!isUserLoggedIn() && <MedicalClaimsSearchForm />}
        {isUserLoggedIn() && <MedicalClaimsProviderList />}
      </Stack>
    </div>
  );
};
